// admin/autoInsertGroupControls.js
export function initAutoInsertGroupControls() {
  const root = document.querySelector('.smart-content-sync-auto-insert');
  if (!root) return;

  function updateCount(detailsEl) {
    const boxes = detailsEl.querySelectorAll('[data-group-locations] input[type="checkbox"]');
    let selected = 0;

    boxes.forEach((b) => {
      if (b.checked) selected += 1;
    });

    const countEl = detailsEl.querySelector('[data-group-count]');
    if (countEl) {
      countEl.textContent = `( ${selected} selected )`;
    }
  }

  root
    .querySelectorAll('details.smart-content-sync-auto-insert__group')
    .forEach((d) => updateCount(d));

  root.addEventListener('change', (e) => {
    const target = e.target;
    if (!(target instanceof HTMLInputElement) || target.type !== 'checkbox') return;

    const detailsEl = target.closest('details.smart-content-sync-auto-insert__group');
    if (detailsEl) updateCount(detailsEl);
  });

  root.addEventListener('click', (e) => {
    const target = e.target;
    if (!(target instanceof Element)) return;

    const button = target.closest('[data-select-all],[data-clear]');
    if (!button) return;

    // Prevent <details> toggle when clicking inside <summary>
    e.preventDefault();
    e.stopPropagation();

    const detailsEl = button.closest('details.smart-content-sync-auto-insert__group');
    if (!detailsEl) return;

    const boxes = detailsEl.querySelectorAll('[data-group-locations] input[type="checkbox"]');

    if (button.hasAttribute('data-select-all')) {
      boxes.forEach((b) => (b.checked = true));
    } else if (button.hasAttribute('data-clear')) {
      boxes.forEach((b) => (b.checked = false));
    }

    updateCount(detailsEl);
  });
}
